import { render, staticRenderFns } from "./CardsTutorial.vue?vue&type=template&id=d244d9e6&"
import script from "./CardsTutorial.vue?vue&type=script&lang=js&"
export * from "./CardsTutorial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports